import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	stroke: "#000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m20 6-11 11-5-5" })
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
